module.exports = __webpack_public_path__ + "static/media/test-attempted.82666bac.jpg";